import React from 'react';

interface StepperProps {
  value: number;
  onChange: (value: number) => void;
  disabled: boolean;
}

const StepperInput: React.FC<StepperProps> = ({ value, onChange }) => {
  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleDecrement = () => {
    if (value > 0) {
      onChange(value - 1);
    }
  };

  return (
    <div className="calculator_stepper">
      <span>
        <button
          className="calculator_stepper_button"
          type="button"
          onClick={handleDecrement}
        >
          <div className="calculator_stepper_circle">
            <img
              src="https://painting-frontend.vercel.app/minus.svg"
              alt="minus"
            />
          </div>
        </button>
      </span>
      <span className="calculator_stepper_input">{value}</span>
      <span>
        <button
          className="calculator_stepper_button"
          type="button"
          onClick={handleIncrement}
        >
          <div className="calculator_stepper_circle">
            <img
              src="https://painting-frontend.vercel.app/plus.svg"
              alt="plus"
            />
          </div>
        </button>
      </span>
    </div>
  );
};

export default StepperInput;
